module.exports = __webpack_public_path__ + "static/media/responsive-img.3eff7978.svg";